import { AbilitySubject, every, not, some } from "@cdv/jazz-auth";
import { CurrentUser, User, UserRole } from "../../api";
import { isAdmin, isAppuser } from "../utils";

export default function defineScoreAbility(can: AbilitySubject<User>): void {
  can("read");
}
